import { useSyncExternalStore } from "react";
import { ITextSelectionConfig } from "@common/components/documentPreview/textSelection/textSelection.types";
import { ExtractedTextResponse } from "@common/components/documentPreview/DocumentPreview.types";

/**
 * What a review in the rail tells the document on the stage, as it changes: which clause to highlight and
 * whether picking text in the document has somewhere to go. Only applied by a pane showing that document.
 */
export interface StageDocumentOverlay {
    documentId: string;
    citationChunkContent?: string;
    textSelection?: ITextSelectionConfig;
    /**
     * Text the review extracted itself, for a document that is not stored and so has no indexed text for
     * the previewer to fetch. Lets a scanned upload switch to its text the way a stored scan does.
     */
    extractedText?: ExtractedTextResponse;
}

// Its own store rather than part of the pane store: the highlighted clause changes on every keystroke in a
// review's clause field, and only the document pane cares.
let overlay: StageDocumentOverlay | undefined;
const listeners = new Set<() => void>();

export function publishStageDocumentOverlay(next: StageDocumentOverlay | undefined) {
    overlay = next;
    listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function useStageDocumentOverlay(): StageDocumentOverlay | undefined {
    return useSyncExternalStore(subscribe, () => overlay);
}
